import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Button,
} from '@material-ui/core';


// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
});


class LoginMenuCmp extends Component {

    render() {
        const { username, IsAuthenticated } = this.props;

               
        if (IsAuthenticated)
            return (
                <Fragment>
                    <Button href="/Identity/Account/Manage">
                        {username}
                    </Button>
                    <Button href="/Identity/Account/LogoutPage">
                        Logout
                    </Button>
                </Fragment>
            );
        else return (
            <Fragment>
                <Button href="/Identity/Account/Login">
                    Login
                </Button>
            </Fragment>
        );
    }
}

LoginMenuCmp.propTypes = {
    username: PropTypes.string.isRequired,
    codiceUtente: PropTypes.string.isRequired,
    IsAuthenticated: PropTypes.bool.isRequired,
};

export default withStyles(styles)(LoginMenuCmp);